import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { refCount, publishReplay } from 'rxjs/operators';
import { ConsentScopesService } from '../config/consent-scopes.service';
var ProfileService = /** @class */ (function () {
    function ProfileService(http, consentScopesService) {
        this.http = http;
        this.consentScopesService = consentScopesService;
        this.consentScopes = this.consentScopesService.getConsentScopes();
    }
    Object.defineProperty(ProfileService.prototype, "profile", {
        get: function () {
            if (!this.profile$) {
                this.profile$ = this.http.get('profile').pipe(publishReplay(1), refCount());
            }
            return this.profile$;
        },
        enumerable: true,
        configurable: true
    });
    ProfileService.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.profile$ = null;
                return [2 /*return*/];
            });
        });
    };
    return ProfileService;
}());
export { ProfileService };
